import { CommonModule, Location } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, signal, ViewChild } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import Helper from 'src/app/Util/helper';
import { PurchasePath } from '../../enums/purchasePath.enum';
import { FormPersistenceService } from '../../services/form-persistence.service';
import { PurchasePathType } from '../../types/purchase-path-type';
import { EnvironmentService } from 'src/app/cloud-subscription/services/environment.service';
import { CloudNotificationService } from 'src/app/services/cloud-notification.service';
import { CloudNotificationStyle } from 'src/app/models/cloud-notification-style.model';
import { NavigationStart, Router, RouterLink } from '@angular/router';
import { quotationGlobalState } from 'src/app/global-state/GlobalState';
import { ContentHeadingComponent } from 'src/app/common-layout/content-heading/content-heading.component';
import { faCloud } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { map, Subject, switchMap, takeUntil } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { LocalStorageService } from 'src/app/services/localstorage.service';
import { StorageKeys } from 'src/app/Util/storage-keys';
import { QuotationService } from '../../services/quotation.service';
import { QuotationPathEnum, QuotationType } from 'src/app/enums/quotation.enum';
import { CloudProfileService } from 'src/app/services/cloud-profile.service';
import { User } from 'src/app/models/user.model';
import { NCacheSubscription } from 'src/app/interfaces/subscription.interface';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-buy-ncache',
  templateUrl: './buy-ncache.component.html',
  styleUrls: ['./buy-ncache.component.sass'],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule , RouterLink,FontAwesomeModule]
})
export class BuyNcacheComponent implements OnInit,OnDestroy {

  @Output() onBuyNCacheSelection = new EventEmitter();
  @Output() updateTabIndex = new EventEmitter<number>();
  @Output() quotationIdEmitter = new EventEmitter<string>();

  @Input() disableInteraction = false;
  private unsubscribe$ = new Subject<void>();
  purchasePath: PurchasePathType = PurchasePath.CreateQuotation;
  faCloud = faCloud
  quotationId: FormControl;
  buyOptionRadioSelfBuy: FormControl;
  buyOptionRadioAcceptInvoice: FormControl;
  routeState:any
  PurchasePath = PurchasePath;
  title: string;
  subscriptionId:string
  quotationPeriod:string
  subscriptionStatus : string = ''
  quotationStatus:any
  guidMatchingPattern: RegExp = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89ab][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/i;
  userDetails: User = null
  nextHeader : string = ''
  cloudSubscription:NCacheSubscription
  constructor(
    private readonly formPersistenceService: FormPersistenceService,
    private readonly location: Location,
    private environmentSvc:EnvironmentService,
    private notificationService:CloudNotificationService,
    private router : Router,
    private localStorageService:LocalStorageService,
    private quotationService:QuotationService,
    private cloudProfileSvc:CloudProfileService,
    private modalSvc: NgbModal,

  ) {
    this.quotationId = new FormControl('', [Validators.required]);
    this.buyOptionRadioSelfBuy = new FormControl('Accept Invite');
    this.buyOptionRadioAcceptInvoice = new FormControl('');
  }

  private getUserDetails(){
    this.cloudProfileSvc.getUserDetails().subscribe({
      next:(res)=>{
        this.userDetails = res

      },
      error:(err)=>{

      }
    })
  }

  ngOnDestroy(): void {
    // this.formPersistenceService.isMidYear = false
  }




  private checkIfQuotationExists(){
    this.environmentSvc.getQuotationById(this.formPersistenceService.customQuotationId).subscribe({
      next:(res)=>{
      },
      error:(err)=>{
        this.notificationService.createToastNotification('Buy NCache',Helper.resolveErrorMessage(err),CloudNotificationStyle.danger)
        return false
      }
    })
  }

  private getSubscriptionId(){
    this.subscriptionId = this.localStorageService.getItemSessionStorage(StorageKeys.SubscriptionId).replace(/\\/g, '')
    return this.subscriptionId
  }

  private getSubscriptionDetails(): void {
    this.formPersistenceService.getSubscriptionDetails(this.subscriptionId)
    .pipe(
      takeUntil(this.unsubscribe$),
      switchMap((subscription) => {
        // Wait for getQuotationPeriod to finish before continuing
        return this.quotationService.getQuotationPeriod(this.subscriptionId).pipe(
          map((quotationPeriod) => ({
            subscription,
            quotationPeriod
          }))
        );
      })
    )
    .subscribe({
      next: ({ subscription, quotationPeriod }) => {
        this.quotationPeriod = quotationPeriod;
        this.cloudSubscription = subscription
        this.subscriptionStatus = subscription.status
        this.title = `Request Quotation (${subscription.vendor})`;
        this.nextHeader = `${subscription.planTitle}`
      },
      error: (err: HttpErrorResponse) => {
        this.notificationService.createToastNotification('get-subscription-details', Helper.resolveErrorMessage(err), CloudNotificationStyle.danger);
      }
    });

  }

  private getReadableQuotationPeriod(quotationPeriod:QuotationType){
    switch(quotationPeriod){
      case QuotationType.MidYear:
        return "Mid Year"
      case QuotationType._24x7:
        return "24x7"
      case QuotationType.Annual:
        return "Annual"
      default:
        return "Awaiting Quotation"
    }
  }

  private getQuotationPeriod(){
    this.quotationService.getQuotationPeriod(this.subscriptionId).subscribe({
      next:(res)=>{
        this.quotationPeriod = res
      },
      error:(err)=>{
      }
    })
  }



  ngOnInit(): void {
    this.getSubscriptionId()
    this.getUserDetails()
    this.getQuotationPeriod()
    this.selectRadioButton()
    this.prePopulateFromGlobalState();
    this.updateOnBuyNCacheSelection();
    quotationGlobalState.resetQuotationGlobalState()
    this.getSubscriptionDetails()
  }

  selectRadioButton(){
    if(this.formPersistenceService.customQuotationId != ''){
      this.purchasePath = PurchasePath.AlreadyCreated;
    }
    else{
      this.purchasePath = PurchasePath.CreateQuotation
    }
  }

  prePopulateFromGlobalState() {
    if (this.formPersistenceService.customQuotationId) this.quotationId.setValue(this.formPersistenceService.customQuotationId);
  }

  updateOnBuyNCacheSelection(): void {

    if (this.purchasePath === PurchasePath.AlreadyCreated && !this.disableInteraction) {
      this.quotationId.enable();

    } else {
      this.quotationId.disable();
    }

    this.onBuyNCacheSelection.emit(this.purchasePath);
  }

  onNext() {
    if(this.quotationId.valid){
      let proceed = true;
      this.environmentSvc.getQuotationById(this.quotationId.value).subscribe({
        next:(res)=>{
          this.quotationStatus = res
          if(res == null){
            this.notificationService.createToastNotification('Buy NCache',Helper.resolveErrorMessage("The requested quotation does not exist or is not associated with your account."),CloudNotificationStyle.danger)
            proceed = false
            return
          }
          else if(this.userDetails != null && this.userDetails.email != this.quotationStatus.subscription.userEmail){
            this.notificationService.createToastNotification('Buy NCache',Helper.resolveErrorMessage("The requested quotation does not exist or is not associated with your account."),CloudNotificationStyle.danger)
            proceed = false
            return
          }
          else if (this.quotationStatus.status == "Cancelled"){
            this.notificationService.createToastNotification('Buy NCache',Helper.resolveErrorMessage("Quotation has been cancelled"),CloudNotificationStyle.danger)
            proceed = false
            return
          }
          else if(this.quotationStatus.status == "Active"){
            this.notificationService.createToastNotification('Buy NCache',Helper.resolveErrorMessage("Quotation is Already Active"),CloudNotificationStyle.danger)
            proceed = false
            return
          }
          this.formPersistenceService.customQuotationId = this.quotationId.value;
        },
        error:(err)=>{
          this.notificationService.createToastNotification('Buy NCache',Helper.resolveErrorMessage(err),CloudNotificationStyle.danger)
          proceed = false
        },
        complete:()=>{
          if(proceed){
            this.formPersistenceService.selectedPath = this.purchasePath;
            quotationGlobalState.populateQuotationId(this.quotationId.value)
            if(Helper.isPlanNonHosted(this.cloudSubscription?.planType)){
              this.router.navigate(['/nonhosted/preview'],{queryParams:{quotationId:this.quotationId.value,frompath:QuotationPathEnum.BUY_NCACHE}})
            }
            else{
              this.router.navigate(['/previewquotation'],{queryParams:{quotationId:this.quotationId.value,frompath:QuotationPathEnum.BUY_NCACHE}})
            }
          }
        }
      })
    }
    else{
      if(this.checkIfPlanNonHosted()){
        this.requestQuotationConfirmation()
      }
      else{
        this.navigateToCreateQuotation()
      }
    }
  }

  navigateToCreateQuotation(){
    this.router.navigate(['/createquotation'],{ state: { isMidYear:history.state.isMidYear,subscriptionStatus :this.subscriptionStatus } })
    this.formPersistenceService.selectedPath = this.purchasePath;
    this.formPersistenceService.customQuotationId = ''
    this.dismiss()
  }

   requestQuotationConfirmation(){
    this.requestNonHostedQuotation()
    this.navigateToCreateQuotation()
  }
  

  private requestNonHostedQuotation(){
    this.quotationService.requestNonHostedQuotation(this.subscriptionId).subscribe({
      next:(res)=>{
        this.navigateToCreateQuotation()
      },
      error:(err)=>{
        this.dismiss()
        this.notificationService.createToastNotification("Buy Ncache",Helper.resolveErrorMessage(err),CloudNotificationStyle.danger)
      }
    })
  }


  canProceedToPricing(): boolean {
    return this.disableInteraction || (this.purchasePath === PurchasePath.AlreadyCreated && !this.quotationId.valid);
  }

  cancel() {
    this.formPersistenceService.customQuotationId = ''
    this.router.navigate(['/subscription/dashboard'])
  }

  get isSupportPlan(): boolean {
    return this.formPersistenceService.ncacheSubscription?.cloudPlan && Helper.isCloudPlanSupport(this.formPersistenceService.ncacheSubscription?.cloudPlan);
  }

 checkIfPlanNonHosted(){
  return Helper.isPlanNonHosted(this.cloudSubscription?.planType)
 }

 
 dismiss(): void {
  this.modalSvc.dismissAll();
};


}
